import { getPartnerInfo } from "../Client/PartnerInfo";
export const getRestaurantInfo = () => {
    let subDomainName = window.location.hostname.split(".")[1];
    let url = sessionStorage.getItem("url");
    if (url) {
        subDomainName = url;
    }
    let { name, logo } = getPartnerInfo(subDomainName);
    return {
        name,
        logo,
    };
};
